// R-1 guard. Source of truth: docs/specs/sprint-3/stage-4-screens.md §3.1.
//
// Async-aware: getToken() async (Capacitor Preferences), синхронный
// `if (!getToken()) <Redirect/>` дал бы truthy Promise → пропускал unauth.
// Идём через useOnboardingState() (он encapsulates token + profile + loading).

import { Redirect } from 'wouter';
import type { ReactNode } from 'react';
import { useOnboardingState } from '@/hooks/useOnboardingState';
import { FullScreenSpinner } from '@/components/FullScreenSpinner';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { state, isLoading } = useOnboardingState();
  if (isLoading) return <FullScreenSpinner />;
  if (state?.kind === 'unauth') return <Redirect to="/signin" />;
  return <>{children}</>;
}
